import styled from 'styled-components'

export const HeaderButtonWrap = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 32px;
	padding: 0 10px;
	border-radius: 8px;
	border: none;
	background: transparent;
	color: ${props => props.theme.COLORS.textw};
	cursor: pointer;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	font-size: 12px;
	font-weight: 500;

	&:hover {
		background: ${props => props.theme.COLORS.point + '20'};
		color: ${props => props.theme.COLORS.point};
		transform: translateY(-1px);
	}

	&:active {
		transform: scale(0.95);
	}

	svg {
		transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	&:hover svg {
		transform: rotate(10deg);
	}

	@media (max-width: 1200px) {
		height: 28px;
		padding: 0 8px;
		gap: 4px;
		font-size: 11px;

		svg {
			width: 16px;
			height: 16px;
		}
	}

	@media (max-width: 900px) {
		height: 26px;
		padding: 0 6px;
		font-size: 10px;

		svg {
			width: 15px;
			height: 15px;
		}
	}
`

export const HeaderButtonInner = styled.span`
	display: flex;
	align-items: center;
	height: auto;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.5px;

	@media (max-width: 1200px) {
		font-size: 10px;
	}

	@media (max-width: 900px) {
		font-size: 9px;
		letter-spacing: 0.3px;
	}
`
